import React from 'react'
import StreetViewIcon from '../../assets/icons/street-view.ico'

const defaultMapName = 'default-map-name'
const defaultCoords = { lat: -34.618145, lng: -58.365294 }
const defaultMapData = {
    options: {
        zoom: 13,
        center: defaultCoords,
        fullscreenControl: false,
        zoomControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        styles: [
            { featureType: 'poi', stylers: [{ visibility: 'off' }] },
            { featureType: 'poi.park', stylers: [{ visibility: 'on' }] },
            { featureType: 'transit', stylers: [{ visibility: 'off' }] },
        ],
    },
    directions: {
        options: {
            preserveViewport: true,
            suppressMarkers: true,
        },
    },
    markers: [
        {
            options: {
                title: 'Demo',
                markerId: 1,
                icon: StreetViewIcon,
                position: defaultCoords,
            },
            infoWindow: {
                options: { content: '<h2>Default Position</h2>Hi!!!' },
                opened: false,
            },
        },
    ],
}

class Component extends React.Component {
    map = null
    markers = []
    directionsRenderer = null
    openInfoWindow = null
    lastClosedMarker = null

    state = {
        firstRenderCompleted: false,
    }

    initMap = (mapName, mapData) => {
        mapName = !mapName ? defaultMapName : mapName
        mapData = !mapData ? {} : mapData
        let options = { ...defaultMapData.options, ...mapData.options }
        this.map = new window.google.maps.Map(
            document.getElementById(mapName),
            options
        )

        if (this.props.handleZoomChange) {
            if (this.props.fitBounds)
                this.map.addListener('zoom_changed', () =>
                    console.error('zoom_changed not compatible with fitBounds')
                )
            else
                this.map.addListener('zoom_changed', () =>
                    this.props.handleZoomChange(this.map.getZoom())
                )
        }
    }

    clearAll = () => {
        for (var i = 0; i < this.markers.length; i++) {
            if (this.markers[i]) this.markers[i].setMap(null)
        }
        this.markers = []

        if (this.openInfoWindow) this.openInfoWindow.close()
        this.openInfoWindow = null

        if (this.directionsRenderer) this.directionsRenderer.setMap(null)
        this.directionsRenderer = null
    }

    addMarkers = (markersData) => {
        this.clearAll()
        markersData = !markersData.length ? [] : markersData

        markersData.forEach((data, index) => {
            data.options.map = this.map
            let marker = new window.google.maps.Marker(data.options)
            let infowindow = !data.infoWindow
                ? null
                : new window.google.maps.InfoWindow(data.infoWindow.options)
            marker.addListener('click', (event) => {
                this.markerClickListener(
                    event,
                    marker,
                    infowindow,
                    data.options.markerId
                )
            })
            this.markers[index] = marker
        })

        if (this.props.fitBounds) {
            let bounds = new window.google.maps.LatLngBounds()
            this.markers.forEach((x) => {
                bounds.extend(x.position)
            })
            this.map.fitBounds(bounds)
        }

        let markerSelected = this.markers.find(
            (x) => x.markerId === this.props.markerSelectedId
        )
        if (markerSelected && this.props.markerSelectedId !== this.lastClosed) {
            window.google.maps.event.trigger(markerSelected, 'click', false)
        }
    }

    markerClickListener = (event, marker, infowindow, markerId) => {
        this.lastClosed = null
        let position = marker.getPosition()
        this.displayRoute(position)
        if (infowindow) {
            window.google.maps.event.addListener(
                infowindow,
                'closeclick',
                () => {
                    this.lastClosed = markerId
                }
            )

            this.openInfoWindow = infowindow
            infowindow.open(this.map, marker)
        }
        this.map.setCenter(position)
        if (event && this.props.handleMarkerOnClick)
            this.props.handleMarkerOnClick(marker.markerId)
    }

    displayRoute(destination) {
        if (!destination || !this.props.currentPosition) return

        let route = {
            origin: this.props.currentPosition,
            destination: destination,
            travelMode: 'WALKING',
        }
        new window.google.maps.DirectionsService().route(route, (body) => {
            if (this.directionsRenderer) this.directionsRenderer.setMap(null)
            this.directionsRenderer = new window.google.maps.DirectionsRenderer(
                {
                    map: this.map,
                    preserveViewport: true,
                    suppressMarkers: true,
                }
            )
            this.directionsRenderer.setDirections(body)
        })
    }

    render() {
        if (this.state.firstRenderCompleted) {
            if (!this.props.visible) {
                if (this.props.markerSelectedId)
                    this.props.handleMarkerOnClick('')
            } else {
                this.map.setCenter(this.props.mapData.options.center)
                this.map.setZoom(this.props.mapData.options.zoom)
                this.addMarkers(this.props.mapData.markers)
            }
        }

        return (
            <div
                id={this.props.id}
                name={this.props.id}
                className={this.props.className}
                style={this.props.style}
            />
        )
    }

    componentDidMount() {
        this.initMap(this.props.id, this.props.mapData)
        this.setState({ firstRenderCompleted: true })
    }
}

export default Component
